import React from "react";
//
import theme from "../../../foundation/Theme";
//
import { ArrowRight, SecondaryCTA, Span } from "./style";

function EnrollNowButton({ onClick, content }) {
  return (
    <SecondaryCTA
      variant="primary1"
      fontSize={["14px", "15px", "16px"]}
      fontFamily={"var(--man-700)"}
      bgColor={theme?.colorsV2?.primary.shade_900}
      hoverColor={theme?.colorsV2?.primary.shade_900}
      onClick={onClick}
      TextColor={theme.colorsV2.primary.shade_25}
    >
      {content}
      <Span variant="span">
        <ArrowRight
          icon="icon-arrow-right"
          color={theme?.colorsV2?.primary?.shade_800}
        />
      </Span>
    </SecondaryCTA>
  );
}

export default EnrollNowButton;
